import { render, staticRenderFns } from "./depResearches.vue?vue&type=template&id=dcd68d56&"
import script from "./depResearches.vue?vue&type=script&lang=js&"
export * from "./depResearches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports